import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from 'ngx-spinner';
import { SPINNER_TEMPLATE } from 'src/app/constants';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { SnackBarType } from 'src/app/models/Snackbar';
import { AlertsService } from 'src/app/services/alerts.service';
import { AuthService } from 'src/app/services/auth.service';
import { ContractsAccessRequestsService } from 'src/app/services/contract-access-requests.service';
import { SnackBarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-contract-access-request-confirmation',
  templateUrl: './contract-access-request-confirmation.component.html',
  styleUrls: ['./contract-access-request-confirmation.component.scss']
})
export class ContractAccessRequestConfirmationComponent implements OnInit {
  isSuccess: boolean = false;
  isProcessing: boolean = true;
  // user: string;
  token: string;
  country: string;
  spinnerTemplate: string = SPINNER_TEMPLATE;
  
  constructor(
    private spinner: NgxSpinnerService,
    private authenticationService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private contractAccessRequestsService: ContractsAccessRequestsService,
    private alertService: AlertsService,
    private translateService: TranslateService, private _snackbarService: SnackBarService
  ) {
    
    // this.user = this.activatedRoute.snapshot.queryParams['user'];
    this.token = this.activatedRoute.snapshot.queryParams['token'];
    this.country = this.activatedRoute.snapshot.queryParams['country'];
  }

  ngOnInit(): void {
    this.spinner.show();

    if (this.token && this.country) {
      this.contractAccessRequestsService
        .confirmAccess(this.country, this.token)
        .subscribe({
          next: (response: ServerResponse<any> ) => this.onActivationSuccess(response),
          error: () => this.onActivationError()
        });
    } else {
      this.isProcessing = false;
      setTimeout(() => {
        this._snackbarService.callSnackBar('NO_TOKEN_PROVIDED', SnackBarType.ERROR);
      }, 0);
    }
  }

  onActivationSuccess(response: ServerResponse<any>): void {
    this.isProcessing = false;
    switch (response.statusCode) {
      case 405:
          this._snackbarService.callSnackBar(response.message, SnackBarType.ERROR);
        break;
      default:
        if (response.data == true) {
          this.isSuccess = true;
          this._snackbarService.callSnackBar('SUCCESS', SnackBarType.SUCCESS);
          break;
        } else {
          this._snackbarService.callSnackBar('INVALID_TOKEN', SnackBarType.ERROR);
        }
        break;
    }
  }

  onActivationError(): void {
    this.isProcessing = false;
    setTimeout(() => {
      this._snackbarService.callSnackBar('INVALID_TOKEN', SnackBarType.ERROR);
    }, 0);
  }

  signIn(): void {
    this.authenticationService.login();
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }

}
